import React, { useState, useEffect } from 'react';
import Loading from '../../Common/Loading';
import { useNavigate } from "react-router-dom";
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";

const EL_SendMail: React.FC = () => {
    const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

    // Form State
    // NOTE: this must match whatever mailbox EMAIL_HOST_USER / your SMTP app password
    // belongs to (e.g. your Gmail address). It's left blank on purpose so you don't
    // accidentally send with a "From" that doesn't match the authenticated account.
    const [fromAddr, setFromAddr] = useState('');
    const [fromName, setFromName] = useState('');
    const [toAddr, setToAddr] = useState('');
    const [subject, setSubject] = useState('Test Subject');
    const [body, setBody] = useState('Test Mail');
    
    // Status State
    const [remarks, setRemarks] = useState('');
    const [queueCount, setQueueCount] = useState<number>(0);
    const [numMailsToProcess, setNumMailsToProcess] = useState('');

    const navigate = useNavigate();

    document.body.style.backgroundColor="azure";
    
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchQueueCount();
    }, []);

    const fetchQueueCount = async () => {
        try {
            const res = await fetch(`${API_BASE_URL}api/sendmail/queue_count`);
            const json = await res.json();
            if (json.count !== undefined) {
                setQueueCount(json.count);
            }
        } catch (err) {
            console.error("Error fetching queue count:", err);
        }
    };

      const handleClose = () => {
        navigate("/SysAdmin");
    };

    const handleSendTest = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setRemarks('');

        if (!fromAddr.trim()) {
            setRemarks("From Address is required — use the same address your SMTP credentials belong to.");
            setLoading(false);
            return;
        }

        try {
            const res = await fetch(`${API_BASE_URL}api/sendmail/send_test`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    from: fromAddr,
                    fromName: fromName,
                    to: toAddr,
                    subject: subject,
                    body: body
                })
            });
            const json = await res.json();

            if (json.error) {
                // Backend returns {success:false, error, message} when the send failed
                // (and it may have been queued for retry instead). Show both so it's
                // clear what actually happened.
                const detail = json.message ? ` (${json.message})` : '';
                setRemarks(`${json.error.replace(/"/g, "'")}${detail}`);
            } else {
                setRemarks(json.message || "Mail sent");
            }
        } catch (err: any) {
            setRemarks(err.message || "An unknown error occurred");
        } finally {
            setLoading(false);
        }
    };

    const handleClearQueue = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setRemarks('');

        try {
            const res = await fetch(`${API_BASE_URL}api/sendmail/process_queue`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    num_mails: numMailsToProcess
                })
            });
            const json = await res.json();

            if (json.error) {
                alert(json.error);
            } else {
                alert(json.message);
                fetchQueueCount(); // Refresh count after processing
            }
        } catch (err) {
            alert("Failed to process queue.");
        } finally {
            setLoading(false);
        }
    };

    // --- Legacy CSS mapping ---
    const styles = {
        container: { 
            border: 'solid 1px teal', 
            fontFamily: 'Arial', 
            fontSize: '12pt',
            margin: '20px auto',
            width: '800px', // Standard constraint for these admin forms
            padding: '10px'
        },
        table: { width: '100%', borderCollapse: 'collapse' as const },
        tdRight: { textAlign: 'right' as const, width: '20%', padding: '5px' },
        tdLeft: { textAlign: 'left' as const, width: '80%', padding: '5px' },
        inputBox: {
            borderColor: '#003300',
            borderStyle: 'solid',
            borderWidth: '1px',
            width: '90%',
            padding: '3px',
            fontFamily: 'Arial',
            fontSize: '12pt'
        },
        smallInputBox: {
            borderColor: '#003300',
            borderStyle: 'solid',
            borderWidth: '1px',
            width: '50px',
            padding: '2px',
            fontFamily: 'Arial',
            fontSize: '12pt'
        }
    };

    return (

                                <><div
            style={{
                backgroundImage: `url(${popimg}), url(${popbg})`,
                backgroundRepeat: "no-repeat, no-repeat",
                backgroundPosition: "left center, right center",
                backgroundSize: "30% 100%, 70% 100%",
                height: "16px",
                color: "white",
                padding: "7px 0px",
                fontWeight: "bold",
                fontSize: "12pt",
                fontFamily: "arial",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <span style={{ marginLeft: "10px" }}></span>
            <img
                src={popclose}
                alt="close"
                height="30px"   
                style={{ cursor: "pointer" }}
                onClick={handleClose} />
        </div><div style={styles.container}>
                {loading && <Loading />}


                <table style={styles.table}>
                    <tbody>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', fontSize: '18pt', paddingBottom: '15px' }}>
                                Sending EMail
                            </td>
                        </tr>

                        <tr>
                            <td style={styles.tdRight}>From Address:</td>
                            <td style={styles.tdLeft}>
                                <input
                                    type="text"
                                    style={styles.inputBox}
                                    value={fromAddr}
                                    placeholder="must match your SMTP account, e.g. youraddress@gmail.com"
                                    onChange={e => setFromAddr(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <td style={styles.tdRight}>From Name:</td>
                            <td style={styles.tdLeft}>
                                <input
                                    type="text"
                                    style={styles.inputBox}
                                    value={fromName}
                                    onChange={e => setFromName(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <td style={styles.tdRight}>To Address:</td>
                            <td style={styles.tdLeft}>
                                <input
                                    type="text"
                                    style={styles.inputBox}
                                    value={toAddr}
                                    onChange={e => setToAddr(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <td style={styles.tdRight}>Subject:</td>
                            <td style={styles.tdLeft}>
                                <input
                                    type="text"
                                    style={styles.inputBox}
                                    value={subject}
                                    onChange={e => setSubject(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ ...styles.tdRight, verticalAlign: 'top' }}>Body:</td>
                            <td style={styles.tdLeft}>
                                <textarea
                                    style={{ ...styles.inputBox, height: '150px', resize: 'vertical' }}
                                    value={body}
                                    onChange={e => setBody(e.target.value)} />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', padding: '15px' }}>
                                <button onClick={handleSendTest} style={{ padding: '4px 20px', cursor: 'pointer' }}>SEND</button>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ ...styles.tdRight, verticalAlign: 'top' }}>Remarks:</td>
                            <td style={{ ...styles.tdLeft, color: 'red' }}>
                                {remarks}
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', width: '100%', padding: '15px 0' }}>
                                <hr />
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', fontSize: '18pt', paddingBottom: '15px' }}>
                                EMails in Queue to be dispatched
                            </td>
                        </tr>
                        <tr>
                            <td style={{ ...styles.tdRight, verticalAlign: 'top', width: '30%' }}>No. of mail in queue:</td>
                            <td style={{ ...styles.tdLeft, width: '70%' }}>
                                <span>{queueCount}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: '10px 5px' }}>
                                Select&nbsp;
                                <input
                                    type="text"
                                    style={styles.smallInputBox}
                                    value={numMailsToProcess}
                                    onChange={e => setNumMailsToProcess(e.target.value)} />
                                &nbsp;from the above and&nbsp;
                                <button onClick={handleClearQueue} style={{ cursor: 'pointer', padding: '3px 10px' }}>
                                    Send Them
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div></>
    );
};

export default EL_SendMail;